module.exports = __webpack_public_path__ + "static/media/personalInfo.cd6ed4b7.svg";